import { Component, OnInit, OnDestroy, TemplateRef, ElementRef, ViewChild, ChangeDetectorRef, HostListener, IterableDiffers, Injectable, ViewEncapsulation, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute, Params, RoutesRecognized } from '@angular/router';
import { Title, DomSanitizer } from '@angular/platform-browser';
import { Location } from '@angular/common';
import { Subscription } from 'rxjs';
import { filter, finalize, pairwise } from 'rxjs/operators';
import { BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
//import { HubConnection, HubConnectionBuilder } from '@aspnet/signalr';
import { HubConnection, HubConnectionBuilder, LogLevel } from "@microsoft/signalr"

import cloneDeep  from 'lodash-es/cloneDeep';

import { AsdBase } from '../model/asd/asd';
import { UserActionProcess } from '../model/asd/asd-properties/asd-userActionProcess';
import { Message, ButtonTextDetails } from '../model/asd/asd-properties/asd-message';
import { FormInit } from '../model/form/form-properties/form-init';
import { IEValue, InterfaceElement } from '../model/asd/asd-properties/asd-ie/asd-interfaceElement';
import { ASDTypes } from '../model/asd/asd-properties/asd-type';
import { InterfaceElementTypes } from '../model/interfaceElement/interfaceElement-properties/interfaceElement-type';
import { InterfaceElementTemplate } from '../model/interfaceElement/interfaceElement-properties/interfaceElement-template';
import { FormInterfaceCommunicatorProperty } from '../model/form/form-properties/form-interfaceCommunicatorProperty';

import { UserActionIdentifiers } from '../model/user/user-properties/user-actionIdentifier';
import { Grid } from '../model/asd/asd-properties/asd-grid';
import { DownloadFile } from '../model/asd/asd-properties/asd-downloadFile';
import { BreadCrumbItem } from '../model/breadCrumb/breadCrumbItem';
import { LocaleTypes } from '../model/locale/locale-type';
import { ASDViewTypes } from '../model/asd/asd-properties/asd-viewType';
import { User } from '../model/user/user';

import { CosyInitializationService } from '../service/initializer/cosy-initialization.service';
import { CosyCommunicationControllerService } from '../service/controller/cosy-communication-controller.service';
import { CosyAppStateDataControllerService } from '../service/controller/cosy-app-state-data-controller.service';
import { CosyDynaeditorControllerService } from '../service/controller/cosy-dynaeditor-controller.service';
import { CosyHtmlElementGenerationService } from '../service/generator/generator-html/cosy-html-element-generation.service';
import { UXControllerService } from '../service/controller/ux-controller.service';

import { AppConfig } from '../app.config';
import { DictionaryTypes } from '../model/dictionary/dictionary-type';
import { InterfaceElementViewAreaTypes } from '../model/interfaceElement/interfaceElement-properties/interfaceElement-viewAreaType';



declare var $: any;
@Component({
  selector: 'app-cosy-asd',
  templateUrl: './cosy-asd.component.html',
  styleUrls: ['./cosy-asd.component.css']
})
export class CosyAsdComponent implements OnInit, OnDestroy {
  private subscriptionUA: Subscription;
  private locationSubscription: Subscription = new Subscription();
  private subscriptionMessage: Subscription;
  public cssUrl: string;
  public iterableDiffer;

  private asd: AsdBase;
  private payloadFromAPI: AsdBase;
  private payloadToAPI: AsdBase = new AsdBase();
  private interfaceElement: InterfaceElement;
  private downloadFile: DownloadFile;
  private messageResponse: Message = new Message();
  public grid: Grid;
  public modalRef: BsModalRef;

  private subscriptions = new Subscription();
  private sub1;
  private sub2;
  private sub3;
  private sub4;

  private sessionID: string;
  private oldSessionID: string;
  private appStateID: string;
  private oldAppStateID: string;
  public referencedGroupID: any;

  private UAID: string = UserActionIdentifiers.LoginUserActionID;
  private uxControllerMatrixID: string;
  private asdViewTemplateID: string;
  public errorMessage: string = '';
  public currentBreadCrumbTitle : string = '';

  private historyPool: { UAIDID: any; IEID: any; SESSIONID: any; COSYOBJ: FormInit; MESSAGE: any; BREADCRUMB: BreadCrumbItem[], TREEGROUPIDS: any[]; ASD: AsdBase}[] = [];
  private formControlMatrices = [];
  private cosyDocuments: any[] = [];
  private payLoadInterfaceElements: InterfaceElement[] = [];

  public loading: boolean = false;

  private IE_TEMPLATE = InterfaceElementTemplate;
  private mgMessageSessionID;
  public signalRCommURL = this.config.getConfig('apiSignalRURL');

  public isAdmin: boolean = false;
  public hubConnection: HubConnection;
  public RTKeyAllowDynaEdit: boolean = true;
  private userLoginObject: User = new User();
  public breadCrumb: BreadCrumbItem[] = [];
  public languageOptions = [];

  @ViewChild('newMsgTemplate') newMsgTemplate: TemplateRef<any>;
  @ViewChild('switchApp') switchApp: ElementRef;
  constructor(
    private activatedRoute: ActivatedRoute,
    private cosyInitializationService: CosyInitializationService,
    private cosyCommunicationControllerService: CosyCommunicationControllerService,
    private cosyAppStateDataControllerService: CosyAppStateDataControllerService,
    private cosyDynaeditorControllerService: CosyDynaeditorControllerService,
    private cosyHtmlElementGenerationService: CosyHtmlElementGenerationService,
    private router: Router,
    private location: Location,
    private modalService: BsModalService,
    private iterableDiffers: IterableDiffers,
    private appStateTitle: Title,
    private config: AppConfig,
    public uxControllerService: UXControllerService,
    private sanitizer: DomSanitizer
  ) {

    this.iterableDiffer = this.iterableDiffers.find([]).create(null);
    this.subscriptionUA = this.uxControllerService.executeUA.subscribe(
      (userActionProcess: UserActionProcess) => this.fetchUserAction(userActionProcess)
    );
    this.subscriptionMessage = this.uxControllerService.showMessage.subscribe(
      (newMessage: Message) => this.openShowModal(newMessage)
    );
  }

  ngOnInit() {
    /* Windows Auth Test
    let currentUser:string
    this.cosyCommunicationControllerService.getCurrentUser().then(res => currentUser = res as string);
    */
    // Laden der Custom und Default CSS-Dateien
    /*    let linkDefault: HTMLLinkElement = document.createElement("link");
        linkDefault.setAttribute('rel', 'stylesheet');
        linkDefault.setAttribute('type', 'text/css');
        linkDefault.setAttribute('id', 'appDefault');
        linkDefault.setAttribute('href', '/assets/default/css/app.css');
        document.head.appendChild(linkDefault);
    */
    this.cssUrl = "/assets/apps/" + this.uxControllerService.appName.replace(/Standard/gi, '').replace(/ /g, '').toLocaleLowerCase() + "/css/app.css";
    let applink: HTMLElement = document.getElementById('app');
    if (applink == null) {
      let link: HTMLLinkElement = document.createElement("link");
      link.setAttribute('rel', 'stylesheet');
      link.setAttribute('content-type', 'text/css');
      link.setAttribute('id', 'app');
      link.setAttribute('href', this.cssUrl);
      link.onerror = function (evt) {
        link.setAttribute('href', '/assets/default/css/app.css');
        document.head.appendChild(link);
      };
      document.head.appendChild(link);
    }

    /*Important! POC may be needed for Future requirements*/
    /*this.router.events
    .pipe(filter((evt: any) => evt instanceof RoutesRecognized), pairwise())
    .subscribe((events: RoutesRecognized[]) => {
      console.log('PREVIOUS URL: ', events[0].urlAfterRedirects);
      if( events[0].urlAfterRedirects == "/server"  && this.historyPool.length==0){
        this.router.navigate(['/server'], { replaceUrl: true });     
      }
      console.log('CURRENT URL:', events[1].urlAfterRedirects);
    });*/

    this.historyPool = [];
    this.activatedRoute.queryParams.subscribe((params: Params) => {
      this.sessionID = params['sessionID'];
    });
    this.processUserAction(UserActionIdentifiers.LoginUserActionID, UserActionIdentifiers.LoginInterfaceElementID, false);
    this.locationSubscription.add(this.location.subscribe(loc => {
      let historyURL: string = loc.url;
      let historySessionID = historyURL.substr(historyURL.indexOf('sessionID') + 10, historyURL.length);

      if (historyURL == '/login') {
        this.router.navigate(['/login']);
      }
      if (historyURL == '/server') {
        this.historyPool = [];
        this.router.navigate(['/server'], { replaceUrl: true });
        history.pushState(null, null, location.href);
        window.onpopstate = function () {
          history.go(1);
        };
        window.location.reload();
      }
      this.loadHistory(historySessionID);
    }));
    this.createSignalRConnection();
    if (this.uxControllerService.ActivePrimaryGroup == "67faa3df-1743-4368-b905-58a433ce1693") {
       this.isAdmin = true;
       this.uxControllerService.isAdmin = true;
    }
  }

  ngOnDestroy() {
    this.subscriptionUA.unsubscribe();
    this.locationSubscription.unsubscribe();
    this.router.navigate(['/server']);
  }
  
  loadHistory(historySessionID: string) {
    if(historySessionID == '') {
      this.currentBreadCrumbTitle = 'Home';
      this.uxControllerService.currentBreadCrumbTitle = 'Home';
      this.router.navigate(['/server']);
    }

    let historyPoolObject;
    let refreshObj;
    for (let h = 0; h < this.historyPool.length; h++) {
      if (historySessionID == this.historyPool[h].SESSIONID) {
        if (this.historyPool[h].MESSAGE == null) {
          this.errorMessage = '';
        }
        historyPoolObject = this.historyPool[h];
      }
    }
    if (historyPoolObject != null) {
      this.appStateID = historyPoolObject['COSYOBJ']['Header']['AppStateID'];
      this.asd = historyPoolObject['ASD'];
      if (historyPoolObject.COSYOBJ.Header.SessionID == this.uxControllerService.cosyFormInitProperties.Header.SessionID) {
        this.synchronizeHistory(this.uxControllerService.cosyFormInitProperties);
      }

      this.uxControllerService.cosyFormInitProperties = historyPoolObject.COSYOBJ;

      this.uxControllerService.cosyFormInitProperties.Header = this.cosyHtmlElementGenerationService.updateCustomizedHeaders(
        this.uxControllerService.cosyFormInitProperties.Header,
        this.uxControllerService.cosyFormInitProperties.ViewAreaList
      );

      this.appStateTitle.setTitle(this.uxControllerService.appStateName);
      this.grid = historyPoolObject.COSYOBJ.TemplateAppStateDocument.Grid;
      refreshObj = this.cosyAppStateDataControllerService.processHistoryRefresh(historyPoolObject.COSYOBJ);

      this.sessionID = historyPoolObject.COSYOBJ.Header.SessionID;
      this.breadCrumb = historyPoolObject.BREADCRUMB;
    }

    if (this.oldAppStateID != this.appStateID) this.cosyCommunicationControllerService.searchOption = [];

    if (refreshObj != null && refreshObj.userActionID !== '') {

      this.processUserAction(refreshObj.userActionID, refreshObj.interfaceElementID, true);
    }
  }

  getInterfaceCommunicatorProps(icProps: FormInterfaceCommunicatorProperty): void {
    this.interfaceElement = this.cosyAppStateDataControllerService.preparePayLoadData(icProps.UXControlInterfaceElementID, icProps.OldStateID, null, null);
    this.asd = this.cosyAppStateDataControllerService.updateAppStateDocument(this.asd, this.interfaceElement, false, null);
    this.uxControllerService.ASD = this.asd;
    this.payLoadInterfaceElements.push(this.interfaceElement);
    this.payloadToAPI = this.cosyAppStateDataControllerService.preparePayLoadASD(this.asd, this.payLoadInterfaceElements, null);
    this.cleanASD(this.asd);
    this.processUserAction(icProps.userActionID, icProps.ClickedUAInterfaceElementID, false);
  }

  fetchUserAction(userActionProcess: UserActionProcess): void {
    this.interfaceElement = this.cosyAppStateDataControllerService.preparePayLoadData(
      userActionProcess.InterfaceElementID,
      userActionProcess.Value,
      userActionProcess.AttributeKey,
      userActionProcess.AdditionalAttributes
    );

    this.asd = this.cosyAppStateDataControllerService.updateAppStateDocument(this.asd, this.interfaceElement, false, userActionProcess.MultiSelect);
    this.uxControllerService.ASD = this.asd;

    if (userActionProcess.AdditionaInterfaceElements != null && userActionProcess.AdditionaInterfaceElements.length > 0) {
      this.payLoadInterfaceElements = userActionProcess.AdditionaInterfaceElements;
    }

    this.payLoadInterfaceElements.push(this.interfaceElement);
    this.payloadToAPI = this.cosyAppStateDataControllerService.preparePayLoadASD(this.asd, this.payLoadInterfaceElements, userActionProcess.MultiSelect);
    if (userActionProcess.ProcessActionOnServer) {
      this.cleanASD(this.asd);
      this.processUserAction(userActionProcess.UserActionID, userActionProcess.InterfaceElementID, false);
    }
  }

  cleanASD(asd: AsdBase) {
    let viewAreas = asd.ViewAreas;
    for (let v of viewAreas) {
      for (let i of v.InterfaceElements) {
        if (i.InterfaceElementGroup != null && (i.TypeDID == InterfaceElementTypes.UXController || i.TypeDID == InterfaceElementTypes.ListUXController)) {
          delete i.InterfaceElementGroup;
        }
      }
    }
  }

  s2ab(s) {
    var buf = new ArrayBuffer(s.length);
    var view = new Uint8Array(buf);
    for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
    return buf;
  }

  processDownloadFile(blob: any) {
    var binaryData = [];
    binaryData.push(this.s2ab(atob(blob.b64Data)));
    const url = window.URL.createObjectURL(new Blob(binaryData, { type: blob.mimeType }));
    const a = document.createElement('a');
    a.setAttribute('style', 'display:none;');
    document.body.appendChild(a);
    a.href = url;
    a.download = blob.fileName;
    a.click();
  }

  synchronizeHistory(modifiedCosyInit: FormInit) {
    if (modifiedCosyInit != null && modifiedCosyInit.Header != null) {
      let historySessionIndex = this.historyPool.map(function (e) { return e.SESSIONID }).indexOf(modifiedCosyInit.Header.SessionID);
      if (historySessionIndex > -1) {
        this.historyPool[historySessionIndex].COSYOBJ = modifiedCosyInit;
      }
    }
  }

  maintainTreeGroupIDs(historyPoolCosyObj: FormInit) {
    let groupIDs: { InterfaceElementID: any, GroupID: any }[] = [];
    for (let va of historyPoolCosyObj.ViewAreaList) {
      for (let iva of va.InterfaceElements) {
        if (iva.TypeDID == InterfaceElementTypes.EntityTree && iva.Values != null && iva.Values.length > 0) {
          groupIDs.push({ InterfaceElementID: iva.InterfaceElementID, GroupID: iva.Values[0].Value })
        }
      }
    }
    return groupIDs;
  }

  updateGroupIdsFromHistory(historyPoolAsd: AsdBase) {

    let colAsdIDIndex = this.historyPool.map(function (e) { return e.COSYOBJ.Header.AppStateID }).indexOf(historyPoolAsd.Header.AppStateID);
    if (colAsdIDIndex > -1) {
      for (let va of historyPoolAsd.ViewAreas) {
        for (let iva of va.InterfaceElements) {
          if (iva.TypeDID == InterfaceElementTypes.EntityTree && iva.Values != null && iva.Values.length > 0) {
            let ivaGroupIndex = this.historyPool[colAsdIDIndex].TREEGROUPIDS.map(function (e) { return e.InterfaceElementID }).indexOf(iva.InterfaceElementID);
            if (ivaGroupIndex > -1) {
              iva.Values[0].Value = this.historyPool[colAsdIDIndex].TREEGROUPIDS[ivaGroupIndex]['GroupID'];
            }
          }
          else if (iva.TypeDID == InterfaceElementTypes.InputPicklist && iva.Values != null && iva.Values.length > 0) {
            let gpUAIDIndex = iva.UserActions.map(function (e) { return e.UserActionID }).indexOf('dededede-55fa-4b61-b4a0-92c8074fb627');
            if (gpUAIDIndex > -1) {
              this.referencedGroupID = iva.Values[0].Value;
            }
          }
          else if (iva.TypeDID == InterfaceElementTypes.EntityTree && iva.Values != null && iva.Values.length == 0) {
            let value: IEValue = new IEValue();
            value.Value = this.referencedGroupID;
            iva.Values.push(value);
          }
        }
      }
    }
    return historyPoolAsd;
  }


  processUserAction(userActionID: string, interfaceElementID: string, historyCalled: boolean) {

    let cosyDocType: string;
    let payloadIEs: InterfaceElement[] = [];
    let historyPoolObject: { UAIDID: any; IEID: any; SESSIONID: any; COSYOBJ: FormInit; MESSAGE: any; BREADCRUMB: BreadCrumbItem[], TREEGROUPIDS: any[], ASD: AsdBase } = {
      UAIDID: null,
      IEID: null,
      SESSIONID: null,
      COSYOBJ: null,
      MESSAGE: null,
      BREADCRUMB: null,
      TREEGROUPIDS: null,
      ASD: null
    };
    this.UAID = userActionID;
    this.cosyDocuments = [];
    this.loading = true;
    this.oldSessionID = this.sessionID;
    this.oldAppStateID = this.appStateID;

    this.synchronizeHistory(this.uxControllerService.cosyFormInitProperties);  
    this.sub1 = this.cosyCommunicationControllerService.executeUserAction(this.payloadToAPI, this.sessionID, userActionID, interfaceElementID).subscribe(
      docAfterUserAction => {
        this.asd = new AsdBase();
        this.payLoadInterfaceElements = [];
        this.payloadToAPI = new AsdBase();
        this.errorMessage = '';
        cosyDocType = this.cosyAppStateDataControllerService.getDocType(docAfterUserAction);
        if (cosyDocType == null || cosyDocType == 'Error') {
          this.loading = false;
          this.payloadToAPI = new AsdBase();
          if (historyCalled == false) {
            historyPoolObject.IEID = interfaceElementID;

            historyPoolObject.UAIDID = userActionID;
            historyPoolObject.MESSAGE = this.errorMessage;

            this.historyPool.push(historyPoolObject);
          }
          this.router.navigate(['/']);
        }
        else {
          if (cosyDocType == ASDTypes.ASD) {
            this.asd = docAfterUserAction['CosyDocument'];
            if (historyCalled == true) {
              this.asd = this.updateGroupIdsFromHistory(this.asd);
            }
            this.uxControllerService.ASD = this.asd;
          } else if (cosyDocType == ASDTypes.PASD) {
            this.payloadFromAPI = docAfterUserAction['CosyDocument'];
            payloadIEs = this.payloadFromAPI.InterfaceElements;
            this.asd = this.cosyAppStateDataControllerService.processPayLoadData(this.asd, payloadIEs, null);
            this.uxControllerService.ASD = this.asd;
          }
          if (this.asd.DownloadFile != null) {
            this.downloadFile = this.asd.DownloadFile;
            this.cosyCommunicationControllerService.postDownLoadFile(UserActionIdentifiers.LoginSessionID, this.downloadFile.FileName).subscribe(fileResult => {
              this.processDownloadFile(fileResult);
            });
          }

          if(this.uxControllerService.appSwitchedUser.login == null) this.uxControllerService.appSwitchedUser.login = 'MyApp';
          
          if (historyCalled == false) {
            historyPoolObject.ASD = this.asd;
          }

          this.sessionID = this.asd.Header.SessionID;
          this.uxControllerService.sessionID = this.sessionID;
          this.appStateID = this.asd.Header.AppStateID;
          this.asdViewTemplateID = this.asd.Header.ViewTemplateID;
          this.cosyDocuments.push(docAfterUserAction);
          this.cosyCommunicationControllerService.localSessionID = this.sessionID;
          this.cosyCommunicationControllerService.sessionID = this.sessionID;
          if (this.oldAppStateID != this.appStateID) {
            this.cosyCommunicationControllerService.searchOption = [];
            this.cosyCommunicationControllerService.searchResult = [];
            this.uxControllerService.page = 0;
            this.uxControllerService.zoom = 'auto';
            this.uxControllerService.rotation = 0;
            this.uxControllerService.documentPdfBase64 = '';
            this.uxControllerService.documentID = '';
          }
          this.asd.Header = this.cosyHtmlElementGenerationService.updateCustomizedHeaders(this.asd.Header, this.asd.ViewAreas);

          //RTKeyShowNullable = false für Wizard
          if (this.asdViewTemplateID == 'f1d8e220-5abc-43e7-ab95-93eb73837ce0') this.cosyCommunicationControllerService.RTKeyShowNullable = false;
          else this.cosyCommunicationControllerService.RTKeyShowNullable = this.uxControllerService.RTKeyShowNullable;

          /*if (this.isAdmin) {
            this.cosyCommunicationControllerService.getRuntimeKey(this.sessionID, "VARIANTID").subscribe(
              key => {
                let variant: string = <string>key["value"];
                if (variant.toLocaleUpperCase() == '3D705C9D-E3D4-43A4-AF92-2D1C58561321') //	COSYadmin Standard
                  this.switchApp.nativeElement.textContent = 'MyApp';
                else this.switchApp.nativeElement.textContent = 'COSYBackend';
              },
              error => console.error('ERROR: ', error),
            );
          }*/

        this.startSignalRConnection();

          
        this.cosyCommunicationControllerService.getLanguageList(this.cosyCommunicationControllerService.localSessionID).subscribe(
          res=> {
            this.languageOptions = [];
            if(res!=null){
              for(let l of res['language']){
                let language = {key: l['ID'], value: l['LanguageCode']};
                this.languageOptions.push(language);
              }
            }
          },
          error => {
            console.error('Error in getting Language Lists:', error);
          }
        )

          this.cosyCommunicationControllerService.getRuntimeKey(this.cosyCommunicationControllerService.localSessionID, "ActiveLanguageCodeID").subscribe(
            locale => {
              this.cosyCommunicationControllerService.langFromServer = locale;
              if (locale['value'] == LocaleTypes.LocaleTypeDE) {
                this.cosyCommunicationControllerService.locale = LocaleTypes.LocaleTypeDE_CODE;
                CosyCommunicationControllerService.currentLocale = LocaleTypes.LocaleTypeDE_CODE;
              }
              else if (locale['value'] == LocaleTypes.LocaleTypeEN) {
                this.cosyCommunicationControllerService.locale = LocaleTypes.LocaleTypeEN_CODE;
                CosyCommunicationControllerService.currentLocale = LocaleTypes.LocaleTypeEN_CODE;
              }
            },
            error => {
              console.error('Error in getting Locale:', error);

            });
            this.cosyCommunicationControllerService.getGetTextShort(this.cosyCommunicationControllerService.localSessionID, DictionaryTypes.DictionaryTypeSelectAll).subscribe(
              textShort => {
                this.cosyCommunicationControllerService.selectAllText = textShort;
              },
              error => {
                console.error('Error in getting textShort:', error);
              });

          if (historyCalled == false) {
            historyPoolObject.IEID = interfaceElementID;
            historyPoolObject.UAIDID = userActionID;
            historyPoolObject.SESSIONID = this.sessionID;
          }
        }
      },
      error => {
        if (error.name == 'HttpErrorResponse') {
          console.error('Server nicht erreichbar, bitte versuchen Sie später noch einmal: ' + error);
          this.errorMessage = 'Server nicht erreichbar, bitte versuchen Sie später noch einmal oder wenden Sie sich an ihren Admin.';
        }
        else {
          console.error('Auf dem Server ist ein Fehler aufgetreten, versuchen Sie es noch einmal oder wenden Sie sich an ihren Admin: ' + error);
          this.errorMessage = 'Auf dem Server ist ein Fehler aufgetreten, versuchen Sie es nochmal einmal oder wenden Sie sich an ihren Admin.';
        }
        this.loading = false;
        this.payloadToAPI = new AsdBase();
        if (historyCalled == false) {
          historyPoolObject.IEID = interfaceElementID;
          historyPoolObject.UAIDID = userActionID;
          historyPoolObject.MESSAGE = this.errorMessage;
          this.historyPool.push(historyPoolObject);
        }
      },
      () => {
        if (cosyDocType != 'Error' && cosyDocType != null) {
          this.payLoadInterfaceElements = [];
          this.uxControllerMatrixID = this.uxControllerService.verifyASDwithUX(this.asd);
          this.sub2 = this.cosyCommunicationControllerService.getFormControlMatrices(this.sessionID, this.uxControllerMatrixID).subscribe(uxMatrices => {
            this.formControlMatrices = uxMatrices['cosyMatrices'];

            UserActionIdentifiers.LoginSessionID = this.sessionID;
            this.router.navigate(['/myapp'], { queryParams: { sessionID: this.sessionID } });
            this.sub3 = this.cosyCommunicationControllerService
              .getOtherCosyDocuments(this.asdViewTemplateID, this.asd.Header.AppStateID, this.uxControllerService.appName.toLocaleLowerCase()).pipe(
                finalize(() => {
                  this.sub4 = this.cosyCommunicationControllerService.getCosyCustomDocument(this.asd).subscribe(
                    casd => {
                      if (casd['CosyDocument'] == null) {
                        casd['CosyDocument'] = this.cosyAppStateDataControllerService.prepareCustomASD(this.asd);
                      }
                     
                      this.cosyDynaeditorControllerService.processedCASD = cloneDeep(casd['CosyDocument']);
                      this.cosyDynaeditorControllerService.previousProcessedCASD =  cloneDeep(casd['CosyDocument']);
                      this.cosyDocuments.push(casd);
                    },
                    error => {
                      console.error('Error in recieving Cosy Custom Document: ' + error);
                      this.errorMessage = 'Error in recieving Cosy Custom Document';
                      if (historyCalled == false) {
                        if (historyCalled == false) {
                          historyPoolObject.IEID = interfaceElementID;
                          historyPoolObject.UAIDID = userActionID;
                          historyPoolObject.MESSAGE = this.errorMessage;
                          historyPoolObject.SESSIONID = this.sessionID;                         
                          this.historyPool.push(historyPoolObject);
                        }
                      }
                    },
                    () => {
                      this.loading = false;
                      this.uxControllerService.cosyFormInitProperties = this.cosyInitializationService.initializeCosyAppState(this.formControlMatrices, this.cosyDocuments);
                      this.appStateTitle.setTitle(this.uxControllerService.appStateName); //verschoben für Google Chrome-History
                      if (historyCalled == false) {
                        this.makeBreadCrumb();
                        historyPoolObject.COSYOBJ = this.uxControllerService.cosyFormInitProperties;
                        historyPoolObject.BREADCRUMB = this.breadCrumb.map(obj => ({ ...obj }));
                        historyPoolObject.TREEGROUPIDS = this.maintainTreeGroupIDs(historyPoolObject.COSYOBJ);
                        this.historyPool.push(historyPoolObject);
                      }
                      this.grid = this.uxControllerService.cosyFormInitProperties.TemplateAppStateDocument.Grid;
                      this.subscriptions
                        .add(this.sub1)
                        .add(this.sub2)
                        .add(this.sub3)
                        .add(this.sub4);
                    }
                  );
                }))
              .subscribe(
                cosyDocs => {
                  for (let c of cosyDocs) {
                    if (c !== 'Error')
                      this.cosyDocuments.push(c);
                  }
                },
                error => {
                  console.error(error);
                }
              );
          });

        }
        if (this.asd.Error != null && this.asd.Error.Number == -7) {
          setTimeout(() => {
            this.loadHistory(this.breadCrumb[this.breadCrumb.length - 2].sessionID);
          }, 1000);
        }
        if (this.appStateID != this.oldAppStateID) window.scrollTo(0, 0);
      }
    );

  }

  public createSignalRConnection() {
    console.log('Creating SignalR connection');
    let builder = new HubConnectionBuilder();
    this.hubConnection = builder.configureLogging(LogLevel.Information).withUrl(this.signalRCommURL).build();
    console.log('Created HubConnection: ', this.hubConnection);

    this.hubConnection
    .start()
    .then(function () {  
      console.log('SignalR is Connected!');  
    })
    .catch(err => console.error('ERROR: SignalR Connection is Lost! : ', err))
    

    this.hubConnection.on('openMessage',(newMessage: Message) => {
        this.openShowModal(newMessage);
    });
    this.hubConnection.on('closeMessage', () => {
        this.closeShowModal();
    });
  }

  public startSignalRConnection() {
     //this.hubConnection.invoke('setConnectionIDToRuntimeKey', this.sessionID);
    this.hubConnection.invoke('setConnectionIDToRuntimeKey', this.sessionID).catch(function (err) {
      return console.error(err.toString());
    })
  }

  public closeShowModal() {
    this.modalRef.hide();
  }

  public showMessage(newMessage: Message) {
    this.openShowModal(newMessage);
  }

  public openShowModal(newMessage: Message) {
    this.mgMessageSessionID = newMessage.sessionID;
    this.messageResponse = this.cosyAppStateDataControllerService.prepareLockedMessage(newMessage);
    let modalOptions: ModalOptions = new ModalOptions();
    modalOptions.backdrop = 'static';
    modalOptions.keyboard = false;
    this.loading = false;
    this.modalRef = this.modalService.show(this.newMsgTemplate, modalOptions);
  }

  exitModalAction(btnProps: ButtonTextDetails) {
   /* if (btnProps.environment == 'server') this.hubConnection.invoke('setAnswer', this.mgMessageSessionID, btnProps.answerCode);
    else this.modalRef.hide();*/
    if (btnProps.environment == 'server'){
      this.hubConnection.invoke('setAnswer', this.mgMessageSessionID, btnProps.answerCode).catch(function (err) {
        return console.error(err.toString());
      });
    } 
    else this.modalRef.hide();
  }

  switchToApp() {
    let responseToken: any = null;
    let oldUserLogin : User = cloneDeep (this.uxControllerService.appSwitchedUser);
    this.uxControllerService.appSwitchedUser.cosyToken =  this.cosyCommunicationControllerService.globalSessionID;
   
    if(oldUserLogin!= null && oldUserLogin.login == 'MyApp') this.uxControllerService.appSwitchedUser.login = 'CosyBackend';
    if(oldUserLogin!= null && oldUserLogin.login == 'CosyBackend') this.uxControllerService.appSwitchedUser.login = 'MyApp';
    
    console.log('UserloginObject: ', this.uxControllerService.appSwitchedUser);

    this.cosyCommunicationControllerService.switchApp(this.uxControllerService.appSwitchedUser).subscribe(
      res => {
        responseToken = res;
      
      },
      error => console.error('Error in recieving Response Token : ', error),
      () => {
        if (responseToken.errorCode == 0) {
          this.sessionID = responseToken.cosyToken;
          this.cosyCommunicationControllerService.globalSessionID = responseToken.cosyToken;
          this.processUserAction(UserActionIdentifiers.LoginUserActionID, UserActionIdentifiers.LoginInterfaceElementID, false);
        } else {
          let responseMsg = this.cosyCommunicationControllerService.responsePerErrorToken(responseToken.errorCode);
          if (responseMsg != null) {
            this.errorMessage = responseMsg.errorMsg;
          }
        }
      }
    );
  }


  makeBreadCrumb() {
    let entityTitle : string = "";
    let entityName : any;
    if (this.appStateID != this.oldAppStateID) {
      let backHistoryPoolElement = this.historyPool.find(history => history.SESSIONID == this.sessionID);
      if (backHistoryPoolElement) {
        this.breadCrumb = backHistoryPoolElement.BREADCRUMB;
      }
      else {
        let historyPoolElement = this.historyPool.find(history => history.SESSIONID == this.oldSessionID);
        
        let breadCrumb: BreadCrumbItem[] = historyPoolElement ? historyPoolElement.BREADCRUMB.map(obj => ({ ...obj })) : [];
        
        if(this.breadCrumb.length == 0){
          let homeBreadCrumbLink : BreadCrumbItem = new BreadCrumbItem();
          homeBreadCrumbLink.title = 'Home';
          homeBreadCrumbLink.sessionID = "";
          homeBreadCrumbLink.viewTypeID = "";
          breadCrumb.push(homeBreadCrumbLink);
        }
        
        let breadCrumbItem: BreadCrumbItem = new BreadCrumbItem();
        breadCrumbItem.sessionID = this.sessionID;
        breadCrumbItem.title = this.appStateTitle.getTitle();
        breadCrumbItem.viewTypeID = this.uxControllerService.ASD.Header.ViewTypeDID;
       
        if(this.uxControllerService.ASD.Header.ViewTypeDID == ASDViewTypes.EntityView){
          entityTitle = this.uxControllerService.ASD.Header.Title;
          entityName =  entityTitle.substring(entityTitle.indexOf('-')+1, entityTitle.length).trim();
          breadCrumbItem.title =  '['+ entityName + ']';
        }
       
        if (!this.uxControllerService.isMenuClick && breadCrumb.length > 0) {
          
          if(breadCrumb.length == 1 && breadCrumb[0].title == 'Home'){
            let appBreadCrumbItem: BreadCrumbItem = new BreadCrumbItem();
            appBreadCrumbItem.title = this.uxControllerService.appName;
            appBreadCrumbItem.sessionID = this.sessionID;
            appBreadCrumbItem.viewTypeID = this.uxControllerService.ASD.Header.ViewTypeDID;
            this.uxControllerService.appSessionID =  appBreadCrumbItem.sessionID;
            breadCrumb.push(appBreadCrumbItem);
          }
         
          if(breadCrumb.length == 2){
            breadCrumbItem.title = this.appStateTitle.getTitle();
          }

          breadCrumb.push(breadCrumbItem);
          
        }

        if (this.uxControllerService.isMenuClick && breadCrumb.length > 0) {
          if(breadCrumb[breadCrumb.length-1].viewTypeID == ASDViewTypes.EntityView){
            breadCrumb.push(breadCrumbItem);
          }
          else if(breadCrumb[breadCrumb.length-1].viewTypeID != ASDViewTypes.EntityView
                  && breadCrumbItem.viewTypeID == ASDViewTypes.EntityView) {
            breadCrumb.pop();
          }
          else {
            breadCrumb.pop();
            breadCrumb.push(breadCrumbItem);
          }
          this.uxControllerService.isMenuClick = false;
        }
        if (breadCrumb.length == 0) {
          breadCrumb.push(breadCrumbItem);
        }
        this.breadCrumb = breadCrumb;
      }
    }
    else if(this.appStateID == this.oldAppStateID){
      
        if(this.asd.Header.ViewTypeDID == ASDViewTypes.EntityView){
          let evIndex = this.breadCrumb.map(function(e){return e.sessionID}).indexOf(this.asd.Header.SessionID);
          entityTitle = this.asd.Header.Title;
          entityName =  entityTitle.substring(entityTitle.indexOf('-')+1, entityTitle.length).trim();
          this.breadCrumb[evIndex].title = '['+entityName+']';
        }  
    }
  }

}
